import { collection, doc, getDocs, orderBy, query, setDoc } from "firebase/firestore";
import pageData from "../utlis/firebaseConstants";
import { BLOG_DOC_NAME, db } from "../firebase/firebaseConfig";
import { allImages } from "../utlis/constants";
import { useContext } from "react";
import { DataContext } from "../services/context";
import axios from "axios";
import { toast } from "react-toastify";
import { Blog } from "../utlis/type";

export const uploadData = async () => {
    try {
        await Promise.all(
            Object.entries(pageData.pages).map(async ([pageKey, pageData]) => {
                try {
                    const pageRef = doc(db, "pages", pageKey);
                    await setDoc(pageRef, pageData);
                } catch (error) {
                    console.log('pageKey', pageKey);
                    console.log('pageData', pageData);
                    console.error("Error uploading data:", error);
                }
            })
        );
        showSuccessToast('Upload data successfully')
        console.log('upload data successful :>> ');
    } catch (error) {
        showErrorToast('Data Uploading error')
        console.error("Error uploading data:", error);
    }
};

export const uploadImages = async () => {
    try {
        let temp = allImages;
        await Promise.all(
            allImages.map(async (key, index) => {
                const res = await uploadImageToCloudinary(key?.url)
                if (res) {
                    // `res` can be either a string (URL) or an object with `url`
                    temp[index].url = typeof res === 'string' ? res : res.url;
                }
            })
        );
        showSuccessToast('Upload image successfully')
        console.log('temp :>> ', temp);
        console.log('upload image successful :>> ');
    } catch (error) {
        showErrorToast('Image Uploading error')
        console.error("Error uploading data:", error);
    }
}



export interface CloudinaryUploadResult {
    url: string;
    public_id?: string;
}

export const uploadImageToCloudinary = async (image: string | File): Promise<CloudinaryUploadResult | string | null> => {
    try {
        let file: File;

        // If image is a File object, use it directly
        if (image instanceof File) {
            file = image;
        } else {
            // If image is a URL string (including data URLs), fetch and convert to File
            const res = await fetch(image);
            const blob = await res.blob();
            const fileName = image.split("/").pop()?.split("?")[0] || "image.png";
            file = new File([blob], fileName, { type: blob.type });
        }

        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", "sattva_unsigned"); // Replace with your actual upload preset
        // formData.append("cloud_name", "dwsfpccgt"); // Replace with your actual Cloudinary cloud name
        formData.append("folder", "sattva-images"); // Replace with your actual Cloudinary cloud name

        const response = await fetch(
            `https://api.cloudinary.com/v1_1/dwsfpccgt/image/upload`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`Upload failed: ${response.statusText}`);
        }

        const data = await response.json();
        console.log("Uploaded Image URL:", data.secure_url);

        // Keep return type backward-compatible: mostly use URL string
        // but also support object with `url` (and optional `public_id`)
        if (data.public_id) {
            return {
                url: data.secure_url,
                public_id: data.public_id
            };
        }

        return data.secure_url as string;
    } catch (error) {
        console.error("Error uploading image:", error);
        return null;
    }
};

export const useData = () => {
    const context = useContext(DataContext);
    if (!context) {
        throw new Error("useData must be used within a DataProvider");
    }
    return context;
};

export const getPageData = (data: any, key: string) => {
    return data.filter((d: any) => d.id === key)?.[0]
}

export const sendMail = async (data: any) => {
    const response = await axios.post('https://satvatech-be-dzqi.onrender.com/api/sendMail', data)
    return response
}


export const showSuccessToast = (message: any) => {
    toast.success(message, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: 'dark',
    });
};

export const showErrorToast = (message: any) => {
    toast.error(message, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
    });
};

export const fetchBlogs = async () => {
    // Create a query against the blogs collection, ordered by createdAt in descending order
    const blogsQuery = query(
        collection(db, BLOG_DOC_NAME),
        orderBy('createdAt', 'desc')
    );

    // Execute the query and get the documents
    const querySnapshot = await getDocs(blogsQuery);

    // Map the documents to our Blog interface
    const blogData: Blog[] = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        createdAt: doc.data().createdAt?.toDate?.() || new Date(),
    } as Blog));

    return blogData
};


export const validatePhoneNumber = (phone: any) => {
    const phoneRegex = /^\+?[1-9]\d{1,14}$/; // E.164 format (International)
    return phoneRegex.test(phone);
}

export function getBackgroundStyle(color: string) {
    if (color.includes("gradient")) {
        return { backgroundImage: color }; // gradient
    } else {
        return { background: color }; // normal color
    }
}